<template>
    <section class="section-wrapper section-2-wrapper">
        <!--
        <pre>{{ JSON.stringify(componentData, null, 2) }}</pre>
        <pre>{{ JSON.stringify(blockData, null, 2) }}</pre>
        -->
        <!--
        <pre>{{ blockData}}</pre>
        <pre>{{ blockDataGrouped}}</pre>
        -->
        <div class="container section-2-container">
            <div class="row">
                <!-- eslint-disable vue/no-v-for-template-key, vue/no-useless-template-attributes -->
                <template v-for="(posts, index1) in blockDataGrouped"
                :postitem="posts" :key="index1"
                >
                    <template v-if="Object.keys(posts).length==1">
                      <div class="col col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 section-2-col-left">
                          <div v-if="(posts[0].content).length==0" class="section-2-content">
                            <a v-if="(posts[0].link).length>0" :href="posts[0].link" :target="(posts[0].target==0?'_self':'_blank')"><img :src="getImages('',posts[0].images)" /></a>
                            <img v-else :src="getImages('',posts[0].images)" />
                          </div>
                          <div v-else class="section-2-content">
                            <!--<div v-html="displayHtmlContent(post.content)"></div>-->
                            <div v-html="displayPostContent(posts[0].content)"></div>
                          </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="col col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 section-2-col-left">
                        <div id="section-2-slide-col" class="col">
                          <b-carousel
                            :id="'section-2-slider'+index"
                            v-model="slide"
                            :interval="5000"
                            controls
                            fade
                            background="#fff"
                            img-width=""
                            img-height=""
                            style=""
                          >
                            <!--<a :href="(post.link).length>0?post.link:'#'" :target="(posts[0].target==0?'_self':'_blank')">-->
                            <b-carousel-slide
                              v-for="(post, index) in posts"
                              :key="index"
                              caption=""
                              text=""
                              :img-src="getImages(post.summary+post.content, post.images)"
                              :class="index==0?'active':''"
                              :id="`section-1-carousel-item${post.id}`"
                              style=""
                              :title="displayEntity(post.title)"
                              :summary="post"
                              v-on:click="gotoLink(post.link, post.target)"
                            ></b-carousel-slide>
                            <!--</a>-->
                            <!--<ol class="carousel-indicators">
                              !-- eslint-disable vue/no-v-for-template-key, vue/no-useless-template-attributes
                              <template v-for="(post, index) in posts"
                                :postitem="post" :key="index"
                                >
                                <li
                                  :class="(index==0)?'active':''"
                                  data-bs-target="#section-1-slider"
                                  :data-bs-slide-to="index"
                                ></li>
                              </template>
                              !-- eslint-enable --
                            </ol>-->
                          </b-carousel>
                        </div>
                      </div>
                    </template>
                </template>
                <!-- eslint-enable -->
            </div>
        </div>
    </section>
</template>

<script>

import PublicService from "../services/public.service";
import FunctionService from "../services/function.service";
//import BannerItem from "./BannerItemCmp";

export default {
  props: ["loggedIn", "componentData", "allData"],
  data() {
    return {
      brand: process.env.VUE_APP_APPNAME,
      AppConst: this.$AppConst,
      posts: [],
      blockData: [],
      blockDataGrouped: [],
    };
  },
  created(){ 
    var vm = this;
    this.getBlockData(this.componentData, vm);
  },
  mounted(){
    
  },
  computed: {

  },
  components: {
    //BannerItem
  },
  methods: {
    getBlockData(cfgData, vm) {
      var resp = PublicService.getAllBlockPublicDataByType(cfgData);
      /*
      console.log("********************************************");
      console.log("resp: ");
      console.log(resp);
      console.log(typeof resp);
      */
      //if(typeof(resp) == 'object' && Object.prototype.hasOwnProperty.call(resp, "data")){
      if (typeof resp == "object") {
        var allData = [];
        resp.then(function (data) {
          //var dtCt = 0;
          data.forEach((dt) => {
            //console.log(dt.data);
            allData.push(dt.data);
            if(typeof(dt.data.child)=='object'){
                vm.blockData.push(dt.data.child);
              }
              else{
                vm.blockData.push(dt.data);
              }
          });
          if(typeof(vm.blockData[0])=="object"){
            vm.groupBanner(vm.blockData[0], vm);
          }
        });
        //console.log(this.blockData);
      }
      //console.log("********************************************");
    },
    groupBanner(data, vm){
      //var dataArr = [];
      var dataArr = {};
      if(typeof(data)=='object'){
        //alert(typeof(data));
        data.forEach((dt) => {
          //alert(typeof(dt));
          if(typeof(dt)=='object'){
            //alert(dt.order);
            //if(!Object.prototype.hasOwnProperty.call(dataArr, dt.order)){
            //if(dt.order in dataArr){
            if(typeof(dataArr[dt.order]) != "object"){
              dataArr[dt.order] = [];
            }
            dataArr[dt.order].push(dt);
            //dataArr[dt.order] = dt;
          }
        });
      }
      //document.write(dataArr);
      vm.blockDataGrouped = dataArr;
      //return(dataArr);
    },
    gotoLink (url, target) {
      if(url.length>0){
        if(target){
          window.open(url, '_blank');
        }
        else{
          window.location.href = url;
        }
      }
      else{
        return false;
      }
    },
    displayPostContent: function (data) {
      return FunctionService.displayPostContent(data);
    },
    removeHTML: function (data) {
      return FunctionService.removeHTML(data);
    },
    displayHtmlContent: function (data) {
      return FunctionService.displayHtmlContent(data);
    },
    getImages: function(str, imgUrl){
      return FunctionService.getImages(str, imgUrl);
    },
    displayEntity: function(str){
      return FunctionService.displayEntity(str);
    },
    shorten: function(str, maxLen, separator = ' '){
      return FunctionService.shorten(str, maxLen, separator);
    },
    genPostLink: function(type, id){
      return FunctionService.genPostLink(type, id);
    },
  },
};

/*
export default {
  props: ["loggedIn"],
  data() {
    return {
      brand: process.env.VUE_APP_APPNAME
    };
  },
  components: {
    BannerItem
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
*/
</script>

<style>
</style>